export default "__VITE_ASSET__78315794__"